import { auth } from '../firebase';

const BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:3800';

/**
 * Fetch paginated activity logs.
 * @param {object} filters
 * @param {string} [filters.resource]     - Module filter (e.g. 'job', 'client')
 * @param {string} [filters.email]        - Filter by user email
 * @param {string} [filters.from]         - ISO date string lower bound
 * @param {string} [filters.to]           - ISO date string upper bound
 * @param {string} [filters.cursor]       - Pagination cursor (last doc ID)
 * @param {number} [filters.limit]        - Records per page (default 50)
 * @param {string} [filters.collection]   - 'activityLog' or 'activityLogArchive'
 */
export const fetchActivityLogs = async (filters = {}) => {
  const user = auth.currentUser;
  if (!user) throw new Error('User not authenticated.');

  const idToken = await user.getIdToken();
  const response = await fetch(`${BASE_URL}/activity-log/list`, {
    method: 'POST',
    headers: {
      Authorization: `Bearer ${idToken}`,
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(filters),
  });

  const data = await response.json();
  if (!response.ok) throw new Error(data.message || `HTTP error ${response.status}`);
  return data;
};
